import React, { useState } from 'react'
import i18n from 'i18n-js'
import Logo from '../../../assets/logo.png'
import { ImFlag, ImMenu } from 'react-icons/im'

import FlagsOverlay from '../FlagsOverlay/FlagsOverlay'
import Sidebar from '../Sidebar/Sidebar'

import './Header.scss'

const Header = props => {

    const [flagsOverlay, toggleFlagsOverlay] = useState(false)
    const [sidebar, toggleSidebar] = useState(false)

    return <>
        <header className="Header">
            <button type="button" aria-label={`${i18n.t('open_menu')} ${i18n.t('opens_in_a_dialog')}`} onClick={() => toggleSidebar(!sidebar)}>
                <ImMenu size="1.25em" />
                <span>{i18n.t('open_menu')}</span>
            </button>
            <img src={Logo} alt="" />
            <button type="button" aria-label={`${i18n.t('adjust_flags_values')} ${i18n.t('opens_in_a_dialog')}`} onClick={() => toggleFlagsOverlay(!flagsOverlay)}>
                <ImFlag size="1.25em" />
                <span>{i18n.t('adjust_flags_values')}</span>
            </button>
        </header>
        <Sidebar active={sidebar} close={() => toggleSidebar(false)} />
        <FlagsOverlay active={flagsOverlay} closeOverlay={() => toggleFlagsOverlay(false)} />
    </>
}

export default Header